import parameterize from 'parameterize';
import React from 'react';
import {
  TABLE_TYPE,
  SUBSECTION_TYPE,
  IMAGE_TYPE,
} from '../../consts/content-types';
import {
  SectionContainer,
  SectionType,
  SectionContent,
  SubSectionContainer,
  SubSectionType,
} from '../../shared-styled/blocks/detailedPageBlocks';
import { snakeToTitle } from '../../utils/caseconverters';
import { sectionIsNotEmpty } from '../../utils/content';
import Image from '../Image/Image.styled';
import SubSectionTextParsed from '../SubSectionTextParsed/SubSectionTextParsed';
import Table from '../Table/Table';

const CustomSection = React.memo(({ el, index, level }) => {
  const body = el?.value?.body || [];
  // Check if at least one item has type === TABLE_TYPE
  const hasTable = body.some((item) => item?.type === TABLE_TYPE);

  // Only check `sectionIsNotEmpty` if there’s no TABLE_TYPE
  if (!hasTable && !sectionIsNotEmpty(body)) return null;

  const renderContentItem = (val, index) => {
    if (val.type === TABLE_TYPE) {
      return <Table key={index} value={val.value} />;
    } else if (val.type === IMAGE_TYPE) {
      return (
        <Image
          key={index}
          src={val.value?.path}
          width={val.value?.width}
          height={val.value?.height}
        />
      );
    } else {
      return <SubSectionTextParsed key={index} html={val.value} />;
    }
  };

  return (
    <SectionContainer $level={level || 0}>
      <SectionType id={parameterize(el.value.header)}>
        {snakeToTitle(el.value.header)}
      </SectionType>
      <SectionContent>
        {body?.map((val, index) => (
          <SubSectionContainer key={index}>
            {val.type === SUBSECTION_TYPE ? (
              <>
                <SubSectionType id={parameterize(val.value.header)}>
                  {val.value.header}
                </SubSectionType>
                {Array.isArray(val.value.content) ? (
                  val.value.content?.map((contentItem, contentIndex) =>
                    renderContentItem(contentItem, contentIndex),
                  )
                ) : (
                  <SubSectionTextParsed html={val.value.content} />
                )}
              </>
            ) : val.type === TABLE_TYPE ? (
              <Table value={val.value} />
            ) : val.type === IMAGE_TYPE ? (
              <Image
                src={val.value?.path}
                width={val.value?.width}
                height={val.value?.height}
              />
            ) : (
              <SubSectionTextParsed html={val.value} />
            )}
          </SubSectionContainer>
        ))}
      </SectionContent>
    </SectionContainer>
  );
});

CustomSection.displayName = 'CustomSection';

export default CustomSection;
